import React, { Component } from 'react'
import { withRouter } from '../../utils/with-router'
import WhoWeAre from './WhoWeAre/WhoWeAre';
import WhatWeDo from './WhatWeDo/WhatWeDo';
import Mission from './Misson/Mission';
import Quotes from './Quotes/Quotes';
import './About.css'

class About extends Component {
    render(){
        return (
            <div>
                <div className='about-title'>
                    <h1>About Us</h1>
                    <h4>We are Silicon Valley Leadership Community</h4>
                </div>
                
                <WhoWeAre/>
                <WhatWeDo/>
                <Mission/>
                {/*<Quotes/>*/}
                <div className="blank">

                </div>
            </div>
        )
    }
}

export default withRouter(About);

